module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ar"
  }, [(_vm.isUploading) ? _c('div', {
    staticClass: "ar__overlay"
  }) : _vm._e(), _vm._v(" "), (_vm.isUploading) ? _c('div', {
    staticClass: "ar-spinner"
  }, [_c('div', {
    staticClass: "ar-spinner__dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "ar-spinner__dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "ar-spinner__dot"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ar-content",
    class: {
      'ar__blur': _vm.isUploading
    }
  }, [_c('div', {
    staticClass: "ar-recorder"
  }, [_c('icon-button', {
    staticClass: "ar-icon ar-icon__lg",
    class: {
      'ar-icon--rec': _vm.isRecording,
      'ar-icon--pulse': _vm.isRecording && _vm.volume > 0.02
    },
    attrs: {
      "name": _vm.iconButtonType
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleRecorder.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('icon-button', {
    staticClass: "ar-icon ar-icon__sm ar-recorder__stop",
    attrs: {
      "name": "stop"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.stopRecorder.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ar-recorder__duration"
  }, [_vm._v(_vm._s(_vm.recordedTime))]), _vm._v(" "), (_vm.time) ? _c('div', {
    staticClass: "ar-recorder__time-limit"
  }, [_vm._v("Длительность записи ограничена: " + _vm._s(_vm.time) + " мин")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ar-records"
  }, [(_vm.audioSource.url) ? _c('audio', {
    ref: "questionPlayer",
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.audioSource.url
    }
  }), _vm._v("\n        Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ar__upload-status"
  }, [(_vm.audioSource.url) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.retry
    }
  }, [_vm._v("Перезаписать")]) : _vm._e(), _vm._v(" "), (_vm.audioSource.url) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.$emit('confirm', _vm.audioSource)
      }
    }
  }, [_vm._v("Сохранить")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-link",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Закрыть")])]), _vm._v(" "), (_vm.uploadStatus) ? _c('div', {
    class: _vm.uploadStatusClasses
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71adb06e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/audiorecording/audioRecorder.vue
// module id = 336
// module chunks = 42